// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1N6nQ","calendarButtons":"ClockData_calendarButtons__25uOm"};